import React from 'react';
import {createRoot} from 'react-dom/client';
import 'core-js/stable';
import 'core-js/actual/array/group';
import 'regenerator-runtime/runtime';
import './i18n.js';
import '../common/axios/index';

import App from './app';

import register from 'utils/serviceworker/register';

// Initiate tracking
import 'utils/trackNudge';

// Page impression
import 'utils/trackPageImpression';

register();

const container = document.getElementById('root');
if (container) {
	const root = createRoot(container);
	root.render(<App />);
}
